import React, { useState, useEffect } from 'react';
import { collection, getDocs, doc, updateDoc, where, query } from 'firebase/firestore';
import { firestore, auth } from '../firebase';
import { LoadingCards } from '../components/LoadingCards';
import { useAuthState } from 'react-firebase-hooks/auth';

export const Bookings = () => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [user, userLoading] = useAuthState(auth);

  useEffect(() => {
    const fetchBookings = async () => {
      try {
        if (user?.uid) {
          console.log(user?.uid)
          const userBookingsQuery = query(
            collection(firestore, 'bookings'),
            where('uid', '==', user.uid) // Replace 'userId' with the correct field name in your Firestore documents
          );

          const querySnapshot = await getDocs(userBookingsQuery);
          const bookingData = [];
          querySnapshot.forEach((doc) => {
            bookingData.push({ id: doc.id, ...doc.data() });
          });
          setBookings(bookingData);
        }
      } catch (error) {
        console.error('Error fetching bookings:', error.message);
      } finally {
        setLoading(false);
      }
    };

    if (user?.uid) {
      fetchBookings();
    }
  }, [userLoading]);

  const handleCancelBooking = async (bookingId) => {
    const confirmCancel = window.confirm('Are you sure you want to cancel this booking?');

    if (confirmCancel) {
      try {
        const bookingRef = doc(firestore, 'bookings', bookingId);
        await updateDoc(bookingRef, { status: 'cancelled' });

        // Remove the canceled booking from the state
        setBookings((prevBookings) =>
          prevBookings.map((booking) =>
            booking.id === bookingId ? { ...booking, status: 'cancelled' } : booking
          )
        );
      } catch (error) {
        console.error('Error cancelling booking:', error.message);
      }
    }
  };

  const handleSupport = (bookingId) => {
    // Implement your support functionality here
    console.log(`Clicked support for booking ID: ${bookingId}`);
  };

  return (
    <div className="p-4">
      {loading && <LoadingCards />} {/* Show LoadingCards while fetching bookings */}
      <div>
        {bookings.map((booking) => (
          <div key={booking.id} className="mb-4 bg-white p-5 rounded-lg">
            <p className="mb-2 text-xs">Name &nbsp; &nbsp; : &nbsp; &nbsp; &nbsp; &nbsp;{booking.surgeryName}</p>
            <p className="mb-2 text-xs">Status &nbsp; &nbsp;: &nbsp; &nbsp; &nbsp; &nbsp;{booking.status}</p>
            <p className="mb-2 text-xs">DoJ &nbsp; &nbsp; &nbsp; &nbsp; : &nbsp; &nbsp; &nbsp; &nbsp;{booking.doj}</p>
            <div className="flex w-full flex-row mt-5">
              <button
                onClick={() => handleSupport(booking.id)}
                className="bg-gray-100 text-balck text-xs mt-2 mr-2 w-[50%] py-2 rounded"
              >
                Support
              </button>
              {booking.status === 'paid' && (
                <button
                  onClick={() => handleCancelBooking(booking.id)}
                  className="bg-red-500 mt-2 text-white text-sm w-[50%] py-2 rounded"
                >
                  Cancel
                </button>
              )}
            </div>
          </div>
        ))}
        {bookings.length === 0 && !loading && <p className="text-center">No bookings found.</p>}
      </div>
      <div className="w-full h-[150px]"></div>
    </div>
  );
};
